import axios from "axios";
import React, { useState, useContext, useEffect } from "react";

import { StoreContext, initialState, SelectedYear } from "./store";
import ActionTypes from "./actionTypes";
import { findDOMNode } from "react-dom";

const accountID = 2;
const AuthStr = "Bearer ".concat(accountID);

const config = { headers: { Authorization: AuthStr } };
const baseUrl = "http://api.pigeonconnect.charmedcoder.com/api/";

//const baseUrl = "http://api.pigeonconnect.com/api/";
//const baseUrl = "http://localhost:64567/api/";

export function PopulateRaceForm(raceResult, dispatch) {
  dispatch({
    actionType: ActionTypes.POPULATE_RACE_FORM,
    payload: raceResult,
  });
}
let fileReader;

export function UpdateRace(dispatch, Race) {
  dispatch({
    actionType: ActionTypes.UPDATE_RACE_OBJECT,
    payload: Race,
  });
}

export function GetRace() {
  return initialState.Race;
}

export function DeleteProduct(dispatch, product, authToken) {
  var endPoint = baseUrl + `Catalog/Remove`;
  const AuthStr = "Token ".concat(authToken.Token + "_" + accountID);
  const config = { headers: { Authorization: AuthStr } };

  return axios
    .post(endPoint, product, config)
    .then(function (response) {
      GetBirds(dispatch);
    })
    .catch(function (error) {
      ErrorHandler(error);
      // dispatch({
      //   actionType: ActionTypes.LOAD_PRODUCTS,
      //   payload: false,
      // });
    });
}

export function SavePost(dispatch, post, authToken) {
  post.AccountID = accountID;
  var endPoint = baseUrl + `Post/SavePost`;
  const AuthStr = "Token ".concat(authToken.Token + "_" + accountID);
  const config = { headers: { Authorization: AuthStr } };

  return axios
    .post(endPoint, post, config)
    .then(function (response) {
      GetPosts(dispatch);
    })
    .catch(function (error) {
      ErrorHandler(error);
      dispatch({
        actionType: ActionTypes.UPDATE_LOGIN,
        payload: false,
      });
    });
}
export function SavePostWithAttachment(dispatch, post, authToken) {
  const AuthStr = "Token ".concat(authToken.Token + "_" + accountID);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: AuthStr,
    },
  };

  const fd = new FormData();
  fd.append("attachedTXT", post.FileData, post.FileData.name);
  fd.append("title", post.Title);
  fd.append("detail", post.Detail);
  fd.append("fileName", post.Attached);

  var endPoint = baseUrl + `Post/SavePostWithUpload`;
  return axios
    .post(endPoint, fd, config)
    .then(function (response) {
      GetPosts(dispatch);
    })
    .catch(function (error) {
      ErrorHandler(error);
      dispatch({
        actionType: ActionTypes.UPDATE_LOGIN,
        payload: false,
      });
    });
}

export function GetPosts(dispatch) {
  var endpoint = baseUrl + "Post/GetPosts";

  return axios
    .get(endpoint, config)
    .then(function (response) {
      dispatch({
        actionType: ActionTypes.LOAD_POSTS,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
}

export function GetAPIVersion(dispatch) {
  var endPoint = baseUrl + `Account/GetAPIVersion`;

  return axios
    .get(endPoint, config)
    .then(function (response) {
      dispatch({
        actionType: ActionTypes.GET_API_VERSION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
}

function ValidateRace(Race) {
  if (Race.FileData === null) return false;

  return true;
}

export function SaveProductWithUpload(Bird, dispatch, authToken) {
  Bird.AccountID = accountID;

  const fd = new FormData();
  for (let i = 0; i < Bird.FileData.length; i++) {
    fd.append("file", Bird.FileData[i], Bird.FileData[i].name);
  }
  for (let i = 0; i < Bird.FileDataPedigree.length; i++) {
    fd.append("file", Bird.FileDataPedigree[i],  "_ped_" + Bird.FileDataPedigree[i].name);
  }
  fd.append("page", Bird.Page);
  fd.append("title", Bird.Title);
  fd.append("description", Bird.Description);
  fd.append("sex", Bird.Sex);
  fd.append("price", Bird.Price);
  fd.append("accountID", Bird.AccountID);
  fd.append("guid", Bird.GUID);
  fd.append("sortingIndex", Bird.SortingIndex);
  fd.append("redHeader", Bird.RedHeader)

  const AuthStr = "Token ".concat(authToken.Token + "_" + accountID);
  const config = { headers: { Authorization: AuthStr } };

  var endPoint = baseUrl + `Catalog/SaveProductWithUpload`;

  return axios
    .post(endPoint, fd, config)
    .then(function (response) {
      dispatch({
        actionType: ActionTypes.LOAD_PRODUCTS,
        payload: [],
      });
      GetBirds(dispatch);
    })
    .catch(function (error) {
      ErrorHandler(error);
      dispatch({
        actionType: ActionTypes.UPDATE_LOGIN,
        payload: false,
      });
    });
}
export function DeleteFile(dispatch, filename, authToken) {
  const AuthStr = "Token ".concat(authToken.Token + "_" + accountID);
  var endPoint = baseUrl + `Catalog/RemoveFile?filename=${filename}`;
  const config = { headers: { Authorization: AuthStr } };
  return axios
    .post(endPoint, {}, config)
    .then(function (response) {
      console.log("Deleted " + filename);
    })
    .catch(function (error) {
      ErrorHandler(error);
    });
}

export function DeleteRace(Race, dispatch, authToken) {
  Race.AccountID = accountID;
  const AuthStr = "Token ".concat(authToken.Token + "_" + accountID);
  var endPoint = baseUrl + `RaceResults/Remove`;
  const config = { headers: { Authorization: AuthStr } };

  return axios
    .post(endPoint, Race, config)
    .then(function (response) {
      GetYears(dispatch);
      RequestResults(dispatch, new Date(Race.RaceDate).getFullYear());
      PopulateRaceForm(initialState.ResetRace, dispatch);
    })
    .catch(function (error) {
      ErrorHandler(error);
      dispatch({
        actionType: ActionTypes.UPDATE_LOGIN,
        payload: false,
      });
    });
}
export function ResetRace(Race, dispatch) {
  dispatch({
    actionType: ActionTypes.RESET_RACE,
    payload: Race,
  });
}
export function SetSelectedYear(dispatch, year) {
  dispatch({
    actionType: ActionTypes.SET_SELECTED_YEAR,
    payload: year,
  });
}

export function RequestResults(dispatch, selectedYear) {
  if (selectedYear == undefined) return;
  var endPoint = baseUrl + `RaceResults/GetResults`;

  const config = {
    headers: { Authorization: AuthStr },
    params: { year: selectedYear },
  };

  return axios
    .get(endPoint, config)
    .then(function (response) {
      dispatch({
        actionType: ActionTypes.LOAD_RACES,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
}

export function GetYears(dispatch) {
  var endPoint = baseUrl + `RaceResults/GetYears`;

  return axios
    .get(endPoint, config)
    .then(function (response) {
      dispatch({
        actionType: ActionTypes.GET_YEARS,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
}

//ROSTERS

export function GetBirds(dispatch) {
  var endPoint = baseUrl + `Catalog/GetAll`;
  return axios
    .get(endPoint, config)
    .then(function (response) {
      dispatch({
        actionType: ActionTypes.LOAD_PRODUCTS,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
}
// export function DeleteRoster(dispatch, Roster, authToken) {
//   var endPoint = baseUrl + `ClubRoster/Remove`;
//   const AuthStr = "Token ".concat(authToken.Token + "_" + accountID);
//   const config = { headers: { Authorization: AuthStr } };

//   return axios
//     .post(endPoint, Roster, config)
//     .then(function (response) {
//       GetRosters(dispatch);
//     })
//     .catch(function (error) {
//       ErrorHandler(error);
//       dispatch({
//         actionType: ActionTypes.UPDATE_LOGIN,
//         payload: false,
//       });
//     });
// }
// export function Logout(dispatch) {
//   dispatch({
//     actionType: ActionTypes.UPDATE_AUTH_TOKEN,
//     payload: {},
//   });
//   dispatch({
//     actionType: ActionTypes.UPDATE_LOGIN,
//     payload: false,
//   });
// }
export function SendMessage(dispatch, message, authToken) {
  message.AccountID = accountID;
  message.Recipient = "rwhull@hotmail.com";
  var endPoint = baseUrl + `Account/SendMessage`;

  return axios
    .post(endPoint, message, config)
    .then(function (response) {
      console.log(response.data);
    })
    .catch(function (error) {
      console.log(error);
    });
}

export function Logout(dispatch) {
  dispatch({
    actionType: ActionTypes.UPDATE_AUTH_TOKEN,
    payload: {},
  });
  dispatch({
    actionType: ActionTypes.UPDATE_LOGIN,
    payload: false,
  });
}
export function Logging(dispatch, userName, password) {
  var endPoint = baseUrl + `Account/Authenticate`;

  //const AuthStr = "Bearer ".concat(accountID); //+ ", Token ".concat(initialState.Token);
  const config = {
    headers: { Authorization: AuthStr },
    params: { userName, password },
  };
  return axios
    .get(endPoint, config)
    .then(function (response) {
      dispatch({
        actionType: ActionTypes.UPDATE_AUTH_TOKEN,
        payload: response.data,
      });

      dispatch({
        actionType: ActionTypes.UPDATE_LOGIN,
        payload: response.data?.Token.length > 0 ? true : false,
      });
      dispatch({
        actionType: ActionTypes.UPDATE_USERNAME,
        payload: userName,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
}

export function UpdateLogin(dispatch, userName, password) {
  var endPoint = baseUrl + `Account/Login`;
  var x = " Token";
  const AuthStr = "Bearer ".concat(accountID, x); //+ ", Token ".concat(initialState.Token);
  const config = {
    headers: { Authorization: AuthStr },
    params: { userName, password },
  };
  return axios
    .get(endPoint, config)
    .then(function (response) {})
    .catch(function (error) {
      console.log(error);
    });
}

function ErrorHandler(error) {
  var msg = "";
  if (error.toString().includes("401")) {
    msg = "Invalid Authentication or token expired.  Please Login to continue.";
  }
  alert(msg);
}
